import { Tile } from "web/components/Tiles"
import { DataTable } from "web/components"

export default function GenericTableTile({
  id,
  tile,
  tileSettingsModal,
  isTemplate = false,
  canEdit = true,
}) {
  async function handleTileSettings() {
    await tileSettingsModal()
  }

  async function handleOnHide() {
    await tile.deleteTile()
  }

  const columns = tile.fields.map((field) => ({
    type: "data",
    label: field.label,
    fieldKind: field.kind,
    fieldFormat: field.format,
    width: field.column_width,
    dataKey: field.key,
    presentation: field.presentation,
  }))

  const {
    sort_field_key: sortField,
    second_group_field_key: secondGroupField,
    group_field_key: groupField,
  } = tile

  const sortDesc = tile.sort_direction === "DESC"
  const groupDesc = tile.group_direction === "DESC"
  const secondGroupDesc = tile.second_group_direction === "DESC"
  const hasFields = tile.fields.length > 0
  const hasData = !isTemplate && tile.data.detail.length > 0

  function TileDataTable() {
    return (
      <>
        <DataTable
          columns={columns}
          data={isTemplate ? tile.getDummyTableData().detail : tile.data.detail}
          showGroupTotals={tile.show_group_totals}
          showGrandTotals={tile.show_grand_totals}
          showDetails={tile.show_details}
          itemLabel={tile.group_label}
          groupTotals={isTemplate ? [] : tile.data.group_totals}
          grandTotals={isTemplate ? [] : tile.data.grand_totals}
          onResizeColumn={null}
          onMoveColumn={null}
          onRowSelectionChanged={null}
          sortColumn={sortField}
          sortDesc={sortDesc}
          groupColumn={groupField}
          groupDesc={groupDesc}
          secondGroupColumn={secondGroupField}
          secondGroupDesc={secondGroupDesc}
          isCompact
          groupCollection={
            isTemplate
              ? tile.getDummyGroupCollection()
              : tile.data.group_collection
          }
        />
        {tile.display_data_limited_message && (
          <div className="flex h-11 items-center text-xs italic">
            Data has been limited to fit within this table.
          </div>
        )}
      </>
    )
  }

  return (
    <Tile
      canEdit={canEdit}
      handleTileSettings={handleTileSettings}
      handleOnHide={handleOnHide}
      id={id}
      title={tile.name}
      breakoutLink={!isTemplate && tile.breakout_link}
    >
      {hasFields && (hasData || isTemplate) ? (
        <TileDataTable />
      ) : (
        <div className="flex h-full items-center justify-center px-10 py-0 text-center italic text-neutral-7">
          {tile.getEmptyMessageForTable()}
        </div>
      )}
    </Tile>
  )
}
